export const types = [
  { name: 'Gym', value: 'Gym' },
  { name: 'School', value: 'School' },
  { name: 'Organization', value: 'Organization' },
];
